import { useLoadAiSubscription } from './use-load-ai-subscription'
import { useLoadSettings } from './use-load-settings'

export const useLoadInitialData = () => {
  useLoadSettings()
  useLoadAiSubscription()
}
